<page-toolbar [pageActions]="pageActions" title="Dashboard Messages Overview"></page-toolbar>

<data-table #table (edit)="onEdit($event)" (remove)="onRemove($event)" [columns]="columns" [dataProvider]="dashboardMessageService"
                [searchAll]="true" title="Dashboard messages"></data-table>
